import { FC } from 'react'
import { useAsset } from 'Assets/hooks/useAsset'
import { AttachmentPdfPreview } from 'Assets/Attachments'
import { Skeleton } from '@sequencehq/core-components'

export const AssetPdfPreview: FC<{
  assetId: string
  children?: React.ReactNode
}> = ({ assetId, children }) => {
  const { data: asset, isLoading } = useAsset(assetId)

  if (isLoading) {
    return <Skeleton height="100%" width="100%" />
  }

  if (!asset) {
    return null
  }

  return (
    <AttachmentPdfPreview url={asset.url} fileName={asset.fileName}>
      {children}
    </AttachmentPdfPreview>
  )
}
